'use strict';

var _extends = Object.assign || function (target) {
  for (var source, i = 1; i < arguments.length; i++) {
    for (var key in source = arguments[i], source) {
      Object.prototype.hasOwnProperty.call(source, key) && (target[key] = source[key]);
    }
  }

  return target;
},
    _createClass = function () {
  function defineProperties(target, props) {
    for (var descriptor, i = 0; i < props.length; i++) {
      descriptor = props[i], descriptor.enumerable = descriptor.enumerable || !1, descriptor.configurable = !0, 'value' in descriptor && (descriptor.writable = !0), Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    return protoProps && defineProperties(Constructor.prototype, protoProps), staticProps && defineProperties(Constructor, staticProps), Constructor;
  };
}(),
    _react = require('react'),
    _react2 = _interopRequireDefault(_react),
    _vstui = require('@vitalsource/vstui');

Object.defineProperty(exports, '__esModule', {
  value: !0
});

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) throw new TypeError('Cannot call a class as a function');
}

function _possibleConstructorReturn(self, call) {
  if (!self) throw new ReferenceError('this hasn\'t been initialised - super() hasn\'t been called');
  return call && ('object' == typeof call || 'function' == typeof call) ? call : self;
}

function _inherits(subClass, superClass) {
  if ('function' != typeof superClass && null !== superClass) throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass);
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: !1,
      writable: !0,
      configurable: !0
    }
  }), superClass && (Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass);
}

var Globe = function (_PureComponent) {
  function Globe() {
    return _classCallCheck(this, Globe), _possibleConstructorReturn(this, (Globe.__proto__ || Object.getPrototypeOf(Globe)).apply(this, arguments));
  }

  return _inherits(Globe, _PureComponent), _createClass(Globe, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(_vstui.Icon, _extends({}, this.props, {
        height: 18,
        width: 18
      }), _react2.default.createElement('path', {
        d: 'M13.08 5.317c.062-.617.58-.883 1.183-.918a6.974 6.974 0 0 1 1.703 3.92c-.09.315-.173.61-.206.823-.14.922-1.06.643-1.843-.279-.782-.92-.91-2.824-.838-3.546m-8.572 4.831c.055-.419.362-1.564 1.09-1.73.724-.169 1.646.16 2.121.582.474.421 1.636-.08 2.243.226.605.308 1.331 1.676.856 2.57-.474.893-2.429 3.853-2.848 3.964-.419.113-.56-.22-.588-1.618-.029-1.396-.479-1.63-1.093-1.647-.98-.028-1.69-.356-1.862-.768-.172-.412.024-1.16.081-1.579m.362-2.793c.308.447-.195.811-.81.56-.413-.17-1.034-.887-1.486-1.685C3.65 3.745 6.124 2 9 2c.307 0 .607.026.903.065-.067.443-.184.987-.287 1.241-.167.42-1.395.838-1.787 1.09-.39.251-.53 1.005-.67 1.424-.14.418-.475.251-.53.027-.056-.223-.029-.446-.335-.614-.308-.167-1.117 0-1.676.363-.559.364-.056 1.313.251 1.76M9 0a9 9 0 1 0 0 18A9 9 0 0 0 9 0'
      }));
    }
  }]), Globe;
}(_react.PureComponent);

Globe.displayName = 'Globe', Globe.vstuiName = 'Icon', exports.default = Globe;